import { useEffect, useState } from "react";
import { Cascader } from "antd";

import SearchInBoard from "../SearchInBoard";
import { BoardType } from "../../type";

import styles from "../../style/index.module.scss";
const SelectedSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12.4894 3.45294L6.11985 10.5946C6.01116 10.7165 5.85638 10.7872 5.69311 10.7896C5.52985 10.792 5.37304 10.7259 5.26081 10.6073L1.50781 6.64139L2.3552 5.83949L5.67179 9.34423L11.6187 2.67639L12.4894 3.45294Z'
      fill='#1C70EE'
    />
  </svg>
);
const expandSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.02044 7.00003L4.2406 3.22019C4.0128 2.99238 4.0128 2.62304 4.2406 2.39523L4.36435 2.27149C4.59215 2.04368 4.9615 2.04368 5.18931 2.27149L9.91784 7.00003L5.18931 11.7286C4.9615 11.9564 4.59215 11.9564 4.36435 11.7286L4.2406 11.6048C4.0128 11.377 4.0128 11.0077 4.2406 10.7799L8.02044 7.00003Z'
      fill='#646566'
    />
  </svg>
);

const Board = ({
  options,
  value,
  searchBoardPlaceholder,
  visibleSearch = true,
  searchValue,
  setSearchValue,
  setSelectValue,
  selectValue,
  onMultipleChange,
  cascaderPanelProps,
  cascaderStyles,
  onlySearchInLastedLayer,
  renderSearchEmpty
}: BoardType) => {
  const [showEmpty, setShowEmpty] = useState(false);

  const processOptions = (options, selectedValue = []) => {
    return options.map((option) => {
      const hasChildren = option.children && option.children.length > 0;
      const isSelected = selectedValue?.[selectedValue?.length - 1] == option.value;
      const isLastLevel = !hasChildren && isSelected;

      return {
        ...option,
        label: isLastLevel ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            {option.label} {SelectedSvg}
          </div>
        ) : (
          option.label
        ),
        children: hasChildren ? processOptions(option.children, selectedValue) : null
      };
    });
  };
  const transformedOptions = processOptions(options, selectValue);
  return (
    <div style={{ padding: 12, position: "relative", height: "100%" }}>
      {visibleSearch && (
        <>
          <SearchInBoard
            options={options}
            renderSearchEmpty={renderSearchEmpty}
            setValue={setSelectValue}
            searchBoardPlaceholder={searchBoardPlaceholder}
            searchValue={searchValue}
            onChange={onMultipleChange}
            value={value}
            setSearchValue={setSearchValue}
            setShowEmpty={setShowEmpty}
            onlySearchInLastedLayer={onlySearchInLastedLayer}
          />
          <div style={{ height: 14 }} />
        </>
      )}

      <Cascader.Panel
        multiple={false}
        expandIcon={expandSvg}
        options={transformedOptions}
        style={{
          ...cascaderStyles
          //  height: showEmpty ? "60px" : cascaderStyles?.height || "300px"
        }}
        value={selectValue}
        onChange={onMultipleChange}
        // showCheckedStrategy='SHOW_CHILD'
        className={styles.overridePanel}
        expandTrigger='hover'
        {...cascaderPanelProps}
      />
    </div>
  );
};

export default Board;
